"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const query = (0, client_1.gql) `
  mutation sendUserEmailVerification {
    sendUserEmailVerification {
      sent
    }
  }
`;
exports.default = query;
//# sourceMappingURL=sendUserEmailVerification.mutation.js.map